import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE, absoluteUrl } from "./siteInfo";

const GSC_TOKEN = process.env.REACT_APP_GSC_TOKEN;

/**
 * Per-page head tags: unique title, description, canonical, Open Graph / Twitter cards,
 * robots directive and JSON-LD. Every routed page renders exactly one of these.
 */
export default function Seo({ title, description = SITE.description, path = "/", image = SITE.ogImage, imageAlt = `${SITE.name}: ${SITE.tagline}`, type = "website", noindex = false, jsonLd }) {
  const fullTitle = !title ? `${SITE.name}: ${SITE.tagline}` : title.includes(SITE.name) ? title : `${title} | ${SITE.name}`;
  const url = absoluteUrl(path);
  const blocks = (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large, max-snippet:-1"} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={imageAlt} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {GSC_TOKEN && path === "/" ? <meta name="google-site-verification" content={GSC_TOKEN} /> : null}
      {blocks.map((block, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(block)}
        </script>
      ))}
    </Helmet>
  );
}
